<template>
  <div class="donation-page">
    <!-- 顶部 Banner -->
    <div class="banner-section">
      <div class="banner-bg">
        <div class="banner-deco deco-1"></div>
        <div class="banner-deco deco-2"></div>
        <div class="banner-deco deco-3"></div>
        <div class="banner-content">
          <div class="badge-wrapper">
            <img :src="require('@/assets/badge.png')" alt="校徽" />
          </div>
          <div class="banner-text">
            <h2 class="banner-title">永春一中</h2>
            <p class="banner-subtitle">百廿周年校庆 · 爱心捐赠</p>
          </div>
        </div>
      </div>
    </div>

    <!-- 项目信息卡片 -->
    <div class="project-card">
      <div class="project-header">
        <h1 class="project-title">永春一中百廿周年校庆爱心捐赠</h1>
        <span class="project-status">进行中</span>
      </div>
      <p class="project-desc">值此永春一中百廿周年校庆之际，诚邀海内外校友及社会各界爱心人士共襄盛举，携手助力永春一中发展。</p>
    </div>

    <!-- 统计数字卡片 -->
    <div class="stats-card">
      <div class="stats-item">
        <div class="stats-number">
          <span class="number-value">{{ donorCount }}</span>
          <span class="number-unit">人</span>
        </div>
        <div class="stats-label">
          <van-icon name="friends-o" class="label-icon" />
          已捐款人数
        </div>
      </div>
      <div class="stats-divider"></div>
      <div class="stats-item">
        <div class="stats-number">
          <span class="number-value">{{ totalAmount }}</span>
          <span class="number-unit">元</span>
        </div>
        <div class="stats-label">
          <van-icon name="balance-o" class="label-icon" />
          累计捐款
        </div>
      </div>
    </div>

    <!-- 爱心榜单 -->
    <div class="donor-list-card">
      <div class="card-header">
        <div class="header-title">
          <div class="title-badge">
            <van-icon name="fire-o" />
          </div>
          <span class="title-text">爱心榜单</span>
        </div>
        <span class="header-action" @click="$router.push('/donation-ranking')">
          查看全部
          <van-icon name="arrow" />
        </span>
      </div>
      <div class="donor-list" :class="{ 'empty': donorList.length === 0 }">
        <div v-if="donorList.length === 0" class="empty-state">
          <van-icon name="records-o" />
          <span>暂无数据</span>
        </div>
        <div v-else class="donor-scroll">
          <div v-for="(donor, index) in displayDonorList" :key="'a' + index" class="donor-item"
            :class="{ 'top-three': index < 3 }">
            <div class="donor-rank" :class="'rank-' + (index + 1)">
              <template v-if="index < 3">
                <div class="rank-medal">
                  <van-icon v-if="index === 0" name="gem-o" />
                  <van-icon v-else-if="index === 1" name="medal-o" />
                  <van-icon v-else name="point-gift-o" />
                </div>
              </template>
              <template v-else>{{ index + 1 }}</template>
            </div>
            <div class="donor-avatar">
              <div class="avatar-text">{{ donor.name.charAt(0) }}</div>
            </div>
            <div class="donor-info">
              <div class="donor-name-row">
                <span class="donor-name">{{ donor.name }}</span>
                <span class="donor-grade">{{ donor.grade }}</span>
              </div>
              <div class="donor-time">{{ donor.time }}</div>
            </div>
            <div class="donor-amount">
              <span class="amount-value">{{ donor.amount }}</span>
              <span class="amount-unit">元</span>
            </div>
          </div>
          <!-- 复制一份实现无缝滚动 -->
          <div v-for="(donor, index) in displayDonorList" :key="'b' + index" class="donor-item"
            :class="{ 'top-three': index < 3 }">
            <div class="donor-rank" :class="'rank-' + (index + 1)">
              <template v-if="index < 3">
                <div class="rank-medal">
                  <van-icon v-if="index === 0" name="gem-o" />
                  <van-icon v-else-if="index === 1" name="medal-o" />
                  <van-icon v-else name="point-gift-o" />
                </div>
              </template>
              <template v-else>{{ index + 1 }}</template>
            </div>
            <div class="donor-avatar">
              <div class="avatar-text">{{ donor.name.charAt(0) }}</div>
            </div>
            <div class="donor-info">
              <div class="donor-name-row">
                <span class="donor-name">{{ donor.name }}</span>
                <span class="donor-grade">{{ donor.grade }}</span>
              </div>
              <div class="donor-time">{{ donor.time }}</div>
            </div>
            <div class="donor-amount">
              <span class="amount-value">{{ donor.amount }}</span>
              <span class="amount-unit">元</span>
            </div>
          </div>
        </div>
      </div>

    </div>

    <!-- 项目介绍 -->
    <div class="intro-card">
      <div class="card-header">
        <div class="header-title">
          <div class="title-badge red">
            <van-icon name="label-o" />
          </div>
          <span class="title-text">项目介绍</span>
        </div>
      </div>
      <div class="intro-content" :class="{ 'expanded': introExpanded }">
        <p>尊敬的广大师生员工、各届校友、各位家长、社会各界热心人士：</p>
        <p>百廿载风雨兼程，双甲子薪火相传。值此永春一中建校百廿周年之际，我们谨向长期以来关心支持永春一中发展的各界人士表示衷心的感谢和崇高的敬意！</p>
        <p>为改善办学条件、奖教奖学、资助贫困学子，永春一中特发起本次爱心捐赠活动。您的每一份爱心，都将化作莘莘学子前行的力量；您的每一次善举，都将铭刻在永春一中发展的史册上。</p>
        <p>我们郑重承诺：所有捐赠款项将专款专用，全部用于学校建设和发展，并接受社会各界的监督。</p>
      </div>
      <div class="intro-toggle" @click="introExpanded = !introExpanded">
        <span>{{ introExpanded ? '收起' : '展开更多' }}</span>
        <van-icon :name="introExpanded ? 'arrow-up' : 'arrow-down'" />
      </div>
    </div>

    <!-- 底部安全区域 -->
    <div class="bottom-safe-area"></div>

    <!-- 底部固定操作栏 -->
    <div class="bottom-actions">
      <div class="action-my" @click="handleMyDonation">
        <div class="my-avatar">
          <van-icon name="user-o" />
        </div>
        <span class="my-label">我的</span>
      </div>
      <div class="action-donate" @click="handleDonate">
        <van-icon name="gem-o" class="donate-icon" />
        立即捐款
      </div>
    </div>
  </div>
</template>

<script>
import request from '@/utils/request';

export default {
  name: 'DonationHome',
  data() {
    return {
      donorCount: 0,
      totalAmount: '0.00',
      introExpanded: false,
      donorList: [],
    };
  },
  computed: {
    displayDonorList() {
      return this.donorList;
    },
  },
  created() {
    this.$store.state.tabBar = this.$route.name;
    this.loadStats();
    this.loadRanking();
  },
  methods: {
    async loadStats() {
      try {
        const res = await request.get('/app/donation/stats');
        if (res.code === 200 || res.code === 0) {
          const data = res.data || {};
          this.donorCount = data.donorCount || 0;
          this.totalAmount = this.formatAmount(data.totalAmount || 0);
        }
      } catch (e) {
        console.error('加载统计数据失败', e);
      }
    },
    async loadRanking() {
      try {
        const res = await request.get('/app/donation/ranking');
        if (res.code === 200 || res.code === 0) {
          const list = res.data || [];
          this.donorList = list.map(item => ({
            name: item.name || '匿名用户',
            grade: item.graveName || '',
            amount: item.amount || 0,
            time: item.payDate || '',
          }));
        }
      } catch (e) {
        console.error('加载爱心榜单失败', e);
      }
    },
    formatAmount(val) {
      if (!val) return '0.00';
      const num = parseFloat(val);
      return num.toLocaleString('zh-CN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },
    handleMyDonation() {
      this.$router.push('/my-donation');
    },
    handleDonate() {
      this.$router.push('/donate');
    },
  },
};
</script>

<style lang="less" scoped>
// 设计 Token
@primary: #8b1a2b;
@primary-light: #b83245;
@primary-dark: #6b1321;
@gold: #c9a96e;
@gold-light: #dcc696;
@gold-dark: #a68b4f;
@bg: #faf7f2;
@card-bg: #ffffff;
@text-primary: #2c1810;
@text-secondary: #6b5b50;
@text-tertiary: #9b8b7b;
@border: #ede5dc;
@shadow: 0 4px 20px rgba(44, 24, 16, 0.06);
@shadow-hover: 0 8px 30px rgba(44, 24, 16, 0.1);

.donation-page {
  min-height: 100vh;
  background: @bg;
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
}

// ========== Banner 区域 ==========
.banner-section {
  position: relative;

  .banner-bg {
    position: relative;
    width: 100%;
    height: 150px;
    background: linear-gradient(
      180deg,
      #a83e4f 0%,
      @primary 60%,
      @primary-dark 100%
    );
    overflow: hidden;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    padding-bottom: 32px;

    .banner-deco {
      position: absolute;
      border-radius: 50%;
      background: rgba(255, 255, 255, 0.06);
      pointer-events: none;
    }

    .deco-1 {
      width: 120px;
      height: 120px;
      top: -30px;
      right: -20px;
      background: rgba(255, 255, 255, 0.08);
    }

    .deco-2 {
      width: 80px;
      height: 80px;
      top: 20px;
      right: 60px;
      background: rgba(255, 255, 255, 0.05);
    }

    .deco-3 {
      width: 160px;
      height: 160px;
      bottom: -60px;
      left: -40px;
      background: rgba(255, 255, 255, 0.04);
    }

    .banner-content {
      display: flex;
      flex-direction: column;
      align-items: center;
      position: relative;
      z-index: 1;

      .badge-wrapper {
        width: 64px;
        height: 64px;
        border-radius: 50%;
        background: rgba(255, 255, 255, 0.95);
        padding: 3px;
        box-shadow: 0 3px 12px rgba(0, 0, 0, 0.2);
        margin-bottom: 12px;

        img {
          width: 100%;
          height: 100%;
          border-radius: 50%;
          object-fit: cover;
        }
      }

      .banner-text {
        text-align: center;

        .banner-title {
          font-size: 22px;
          font-weight: 800;
          color: #fff;
          margin: 0 0 5px;
          letter-spacing: 4px;
          text-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
        }

        .banner-subtitle {
          font-size: 12px;
          color: rgba(255, 255, 255, 0.85);
          margin: 0;
          letter-spacing: 2px;
        }
      }
    }
  }
}

// ========== 项目信息卡片 ==========
.project-card {
  margin: -30px 16px 12px;
  padding: 20px;
  background: @card-bg;
  border-radius: 16px;
  box-shadow: @shadow;
  position: relative;
  z-index: 1;

  .project-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 12px;

    .project-title {
      font-size: 16px;
      font-weight: 700;
      color: @text-primary;
      margin: 0;
      line-height: 1.3;
      flex: 1;
    }

    .project-status {
      display: inline-flex;
      align-items: center;
      padding: 4px 10px;
      background: linear-gradient(135deg, @primary-light, @primary);
      color: #fff;
      font-size: 11px;
      font-weight: 600;
      border-radius: 20px;
      margin-left: 10px;
      flex-shrink: 0;
      letter-spacing: 1px;

      &::before {
        content: '';
        width: 5px;
        height: 5px;
        background: #7cfc00;
        border-radius: 50%;
        margin-right: 5px;
        animation: pulse 2s infinite;
      }
    }
  }

  .project-desc {
    font-size: 13px;
    color: @text-secondary;
    line-height: 1.7;
    margin: 0;
  }
}

// ========== 统计卡片 ==========
.stats-card {
  margin: 12px 16px;
  padding: 24px 16px;
  background: linear-gradient(135deg, @primary, @primary-dark);
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  position: relative;
  overflow: hidden;
  box-shadow: 0 6px 24px rgba(139, 26, 43, 0.25);

  &::before {
    content: '';
    position: absolute;
    top: -50%;
    right: -20%;
    width: 200px;
    height: 200px;
    background: radial-gradient(
      circle,
      rgba(201, 169, 110, 0.15),
      transparent 70%
    );
    pointer-events: none;
  }

  &::after {
    content: '';
    position: absolute;
    bottom: -30%;
    left: -10%;
    width: 150px;
    height: 150px;
    background: radial-gradient(
      circle,
      rgba(201, 169, 110, 0.1),
      transparent 70%
    );
    pointer-events: none;
  }

  .stats-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    z-index: 1;

    .stats-number {
      display: flex;
      align-items: baseline;
      margin-bottom: 8px;

      .number-value {
        font-size: 28px;
        font-weight: 800;
        color: #fff;
        letter-spacing: 1px;
        font-family: 'DIN Alternate', 'Helvetica Neue', Arial, sans-serif;
      }

      .number-unit {
        font-size: 13px;
        color: rgba(255, 255, 255, 0.7);
        margin-left: 3px;
      }
    }

    .stats-label {
      display: flex;
      align-items: center;
      font-size: 12px;
      color: rgba(255, 255, 255, 0.8);

      .label-icon {
        font-size: 14px;
        margin-right: 4px;
        color: @gold-light;
      }
    }
  }

  .stats-divider {
    width: 1px;
    height: 40px;
    background: linear-gradient(
      to bottom,
      transparent,
      rgba(255, 255, 255, 0.3),
      transparent
    );
  }
}

// ========== 爱心榜单卡片 ==========
.donor-list-card {
  margin: 12px 16px;
  padding: 16px;
  background: @card-bg;
  border-radius: 16px;
  box-shadow: @shadow;

  .card-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;

    .header-title {
      display: flex;
      align-items: center;

      .title-badge {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 28px;
        height: 28px;
        background: linear-gradient(135deg, @gold-light, @gold);
        border-radius: 8px;
        margin-right: 8px;
        color: #fff;
        font-size: 14px;

        &.red {
          background: linear-gradient(135deg, @primary-light, @primary);
        }
      }

      .title-text {
        font-size: 16px;
        font-weight: 700;
        color: @text-primary;
      }
    }

    .header-action {
      display: flex;
      align-items: center;
      font-size: 13px;
      color: @text-tertiary;
      cursor: pointer;
      transition: color 0.2s;

      .van-icon {
        font-size: 12px;
        margin-left: 2px;
      }

      &:active {
        color: @primary;
      }
    }
  }

  .donor-list {
    height: 400px;
    overflow: hidden;

    &.empty {
      height: 120px;
      display: flex;
      align-items: center;
      justify-content: center;

      .empty-state {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 8px;
        color: @text-tertiary;
        font-size: 14px;

        .van-icon {
          font-size: 32px;
        }
      }
    }

    .donor-scroll {
      animation: scrollUp 20s linear infinite;

      &:hover {
        animation-play-state: paused;
      }
    }

    .donor-item {
      display: flex;
      align-items: center;
      padding: 12px 0;
      border-bottom: 1px solid @border;
      transition: background 0.2s;

      &:last-child {
        border-bottom: none;
      }

      &.top-three {
        background: linear-gradient(
          90deg,
          rgba(201, 169, 110, 0.04),
          transparent
        );
        border-radius: 8px;
        padding-left: 8px;
        padding-right: 8px;
        margin: 0 -8px;
        border-bottom: none;
        margin-bottom: 4px;
      }

      .donor-rank {
        width: 32px;
        height: 32px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 13px;
        font-weight: 600;
        color: @text-tertiary;
        flex-shrink: 0;
        margin-right: 10px;

        &.rank-1 {
          .rank-medal {
            background: linear-gradient(135deg, #f5d76e, #d4a843);
            color: #fff;
          }
        }

        &.rank-2 {
          .rank-medal {
            background: linear-gradient(135deg, #d0d8e0, #a8b0b8);
            color: #fff;
          }
        }

        &.rank-3 {
          .rank-medal {
            background: linear-gradient(135deg, #e8b896, #c4784a);
            color: #fff;
          }
        }

        .rank-medal {
          width: 28px;
          height: 28px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 14px;
          box-shadow: 0 2px 6px rgba(0, 0, 0, 0.12);
        }
      }

      .donor-avatar {
        width: 36px;
        height: 36px;
        border-radius: 50%;
        background: linear-gradient(135deg, @primary-light, @primary);
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 10px;
        flex-shrink: 0;

        .avatar-text {
          font-size: 14px;
          font-weight: 600;
          color: #fff;
        }
      }

      .donor-info {
        flex: 1;
        min-width: 0;

        .donor-name-row {
          display: flex;
          align-items: center;
          margin-bottom: 3px;

          .donor-name {
            font-size: 14px;
            font-weight: 600;
            color: @text-primary;
            margin-right: 6px;
          }

          .donor-grade {
            font-size: 11px;
            color: @text-tertiary;
            background: @bg;
            padding: 1px 6px;
            border-radius: 10px;
          }
        }

        .donor-time {
          font-size: 11px;
          color: @text-tertiary;
        }
      }

      .donor-amount {
        text-align: right;
        flex-shrink: 0;
        margin-left: 8px;

        .amount-value {
          font-size: 16px;
          font-weight: 700;
          color: @primary;
          font-family: 'DIN Alternate', 'Helvetica Neue', Arial, sans-serif;
        }

        .amount-unit {
          font-size: 11px;
          color: @text-tertiary;
          margin-left: 1px;
        }
      }
    }
  }

  .load-more {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 14px 0 4px;
    font-size: 13px;
    color: @text-tertiary;
    cursor: pointer;
    transition: color 0.2s;

    .van-icon {
      font-size: 12px;
      margin-left: 4px;
    }

    &:active {
      color: @primary;
    }
  }
}

// ========== 项目介绍卡片 ==========
.intro-card {
  margin: 12px 16px;
  padding: 16px;
  background: @card-bg;
  border-radius: 16px;
  box-shadow: @shadow;

  .card-header {
    display: flex;
    align-items: center;
    margin-bottom: 12px;

    .header-title {
      display: flex;
      align-items: center;

      .title-badge {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 28px;
        height: 28px;
        background: linear-gradient(135deg, @gold-light, @gold);
        border-radius: 8px;
        margin-right: 8px;
        color: #fff;
        font-size: 14px;

        &.red {
          background: linear-gradient(135deg, @primary-light, @primary);
        }
      }

      .title-text {
        font-size: 16px;
        font-weight: 700;
        color: @text-primary;
      }
    }
  }

  .intro-content {
    max-height: 72px;
    overflow: hidden;
    transition: max-height 0.3s ease;

    &.expanded {
      max-height: 500px;
    }

    p {
      font-size: 13px;
      color: @text-secondary;
      line-height: 1.8;
      margin: 0 0 8px;
      text-align: justify;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  .intro-toggle {
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: 12px;
    margin-top: 4px;
    font-size: 13px;
    color: @primary;
    cursor: pointer;
    border-top: 1px dashed @border;

    .van-icon {
      font-size: 12px;
      margin-left: 4px;
    }

    &:active {
      opacity: 0.7;
    }
  }
}

// ========== 底部操作栏 ==========
.bottom-safe-area {
  height: 80px;
}

.bottom-actions {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 16px calc(10px + constant(safe-area-inset-bottom));
  padding: 10px 16px calc(10px + env(safe-area-inset-bottom));
  background: #fff;
  border-top: 1px solid @border;
  box-shadow: 0 -4px 20px rgba(44, 24, 16, 0.06);
  z-index: 100;

  .action-my {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 52px;
    cursor: pointer;
    flex-shrink: 0;

    .my-avatar {
      width: 36px;
      height: 36px;
      border-radius: 50%;
      background: @bg;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 18px;
      color: @text-secondary;
      margin-bottom: 4px;
      border: 1px solid @border;
      transition: all 0.2s;
    }

    .my-label {
      font-size: 10px;
      color: @text-tertiary;
    }

    &:active {
      .my-avatar {
        background: @primary;
        color: #fff;
        border-color: @primary;
      }

      .my-label {
        color: @primary;
      }
    }
  }

  .action-donate {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 46px;
    border-radius: 23px;
    font-size: 15px;
    font-weight: 700;
    cursor: pointer;
    transition: transform 0.15s, box-shadow 0.15s;
    background: linear-gradient(135deg, @primary-light, @primary);
    color: #fff;
    box-shadow: 0 4px 14px rgba(139, 26, 43, 0.35);
    letter-spacing: 2px;

    .donate-icon {
      font-size: 18px;
      margin-right: 6px;
    }

    &:active {
      transform: scale(0.97);
      background: linear-gradient(135deg, @primary, @primary-dark);
      box-shadow: 0 2px 10px rgba(139, 26, 43, 0.25);
    }
  }
}

// ========== 动画 ==========
@keyframes pulse {
  0% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.5;
    transform: scale(1.2);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}

@keyframes scrollUp {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(-50%);
  }
}
</style>
